// extracted by mini-css-extract-plugin
export default {"productGallery":"nK-z","inQuickShop":"oK-z"};